import React from "react";

const CLASS_BY_STATUS = {
  approved: "bg-[#eaf0ec] text-[#3d5a45]",
  pending: "bg-[#fdf6ed] text-[#8a5a1f]",
  rejected: "bg-[#fcecec] text-[#8f2c2c]",
};

export default function StatusPill({ status }) {
  const cls = CLASS_BY_STATUS[status] || "bg-[#f0f0ed] text-[#575752]";
  return (
    <span className={`rounded-full px-2 py-0.5 text-[10px] font-medium ${cls}`}>
      {status}
    </span>
  );
}
